export default __webpack_public_path__ + "static/media/cnbc.7909f8e5.png";